// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.incyia-pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px 16px;
  padding: 10px 16px 12px;
  border-top: 1px solid #eef2f7;
  background: #fff;
  font-family: Lato, sans-serif;
}

.incyia-pager-range {
  font-size: 12.5px;
  font-weight: 600;
  color: #5f7484;
  font-variant-numeric: tabular-nums;
}

.incyia-pager-controls {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}

.incyia-pager-size {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  font-weight: 600;
  color: #8a9ba7;
}

.incyia-pager-size select {
  height: 32px;
  min-width: 56px;
  padding: 0 8px;
  border: 1px solid #dfe7e8;
  border-radius: 8px;
  background: #f7fafa;
  color: #0b1e2d;
  font-family: Lato, sans-serif;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.incyia-pager-size select:focus {
  outline: 2px solid rgba(13, 155, 135, 0.35);
  outline-offset: 1px;
  border-color: #0d9b87;
}

.incyia-pager-btns {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.incyia-pager-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  border: 1px solid #dfe7e8;
  background: #fff;
  color: #00146d;
  font-size: 18px;
  line-height: 1;
  cursor: pointer;
  display: grid;
  place-items: center;
  transition: background 0.12s, border-color 0.12s;
}

.incyia-pager-btn:hover:not(:disabled) {
  background: #eef7f5;
  border-color: #c5e4dc;
}

.incyia-pager-btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.incyia-pager-page {
  min-width: 52px;
  text-align: center;
  font-size: 12.5px;
  font-weight: 700;
  color: #0b1e2d;
  font-variant-numeric: tabular-nums;
}
`, "",{"version":3,"sources":["webpack://./src/components/common/TablePager.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;EACvB,6BAA6B;EAC7B,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,cAAc;EACd,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kCAAkC;AACpC","sourcesContent":[".incyia-pager {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px 16px;\n  padding: 10px 16px 12px;\n  border-top: 1px solid #eef2f7;\n  background: #fff;\n  font-family: Lato, sans-serif;\n}\n\n.incyia-pager-range {\n  font-size: 12.5px;\n  font-weight: 600;\n  color: #5f7484;\n  font-variant-numeric: tabular-nums;\n}\n\n.incyia-pager-controls {\n  display: inline-flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.incyia-pager-size {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  font-size: 12px;\n  font-weight: 600;\n  color: #8a9ba7;\n}\n\n.incyia-pager-size select {\n  height: 32px;\n  min-width: 56px;\n  padding: 0 8px;\n  border: 1px solid #dfe7e8;\n  border-radius: 8px;\n  background: #f7fafa;\n  color: #0b1e2d;\n  font-family: Lato, sans-serif;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.incyia-pager-size select:focus {\n  outline: 2px solid rgba(13, 155, 135, 0.35);\n  outline-offset: 1px;\n  border-color: #0d9b87;\n}\n\n.incyia-pager-btns {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n}\n\n.incyia-pager-btn {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  border: 1px solid #dfe7e8;\n  background: #fff;\n  color: #00146d;\n  font-size: 18px;\n  line-height: 1;\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n  transition: background 0.12s, border-color 0.12s;\n}\n\n.incyia-pager-btn:hover:not(:disabled) {\n  background: #eef7f5;\n  border-color: #c5e4dc;\n}\n\n.incyia-pager-btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.incyia-pager-page {\n  min-width: 52px;\n  text-align: center;\n  font-size: 12.5px;\n  font-weight: 700;\n  color: #0b1e2d;\n  font-variant-numeric: tabular-nums;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
